/**
 * Neutral boot surface used while auth, tenant, and branding queries resolve.
 * It intentionally avoids logos, app names, and brand colors that may belong
 * to the fallback brand rather than the active tenant.
 */
export function BrandSplash({
  message,
}: {
  message?: string;
  tone?: 'neutral' | 'brand';
}) {
  return <BrandBootBlank message={message} />;
}

export function BrandBootBlank({ message = 'Chargement...' }: { message?: string }) {
  return (
    <div
      className="fixed inset-0 z-[9999] flex min-h-screen w-screen items-center justify-center bg-background px-6"
      style={{ background: 'var(--background, #fff)' }}
      role="status"
      aria-live="polite"
    >
      <div className="w-full max-w-[360px] space-y-5">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-2 border-muted border-t-primary/80" />
        <div className="space-y-3">
          <div className="mx-auto h-3 w-28 animate-pulse rounded-full bg-muted" />
          <div className="h-8 w-full animate-pulse rounded-md bg-muted/80" />
          <div className="grid grid-cols-3 gap-2">
            <div className="h-16 animate-pulse rounded-md bg-muted/60" />
            <div className="h-16 animate-pulse rounded-md bg-muted/60" />
            <div className="h-16 animate-pulse rounded-md bg-muted/60" />
          </div>
        </div>
        <span className="sr-only">{message}</span>
      </div>
    </div>
  );
}
